import React from "react";
import RequestAccessForm from "../../Guard/Modal/RequestAccessForm";
import { Box } from "@mui/material";
import CustomAddChipSearch from "../../../../../components/CustomAddChipSearch";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";
import {PUBLIC_SEARCH_USERS_BY_USER_TYPE} from "../../../../../reduxToolkit/Commons/CommonsApi";
import {userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";

/**
 * VisitDetailsForm
 *
 * Component to render the visit details section of the QR request access form.
 * Allows selection of an employee/host to visit and uploading files if needed.
 * Wraps the RequestAccessForm component and passes all necessary props.
 *
 * @author Karen Yunuen Pozos Arias
 * @jobTitle Full Stack Developer - IBL
 * @email kpozos@ibl.mx
 *
 * @param {Function} t - Translation function from react-i18next
 * @param {Array} employeeList - Array of selected employees (hosts)
 * @param {Function} setEmployeeList - Function to update the selected employees state
 * @param {boolean} emptyFields - Flag to indicate if required fields are empty
 * @param {Object} requestAccessItem - Current request access item model
 * @param {Object} photoPickerFile - File object from photo picker
 * @param {Function} setPhotoPickerFile - Function to update the photo picker file state
 * @param {Array} employeeOptions - Array of available employees to select from
 * @param {Function} handleChange - Function to handle input changes for the requestAccessItem
 *
 * @returns {JSX.Element} The visit details form section
 */
const VisitDetailsForm = ({
                              t,
                              employeeList,
                              setEmployeeList,
                              emptyFields,
                              requestAccessItem,
                              photoPickerFile,
                              setPhotoPickerFile,
                              handleChange
                          }) => {

    return (
        <div className="row background-general-00 box-shadow-primary-900-opacity-10 p-24px border-radius-8px">
            <Box className="col-12 mb-4 text-center">
                <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-capitalize">{t("visit_details")}</p>
            </Box>

            <div className='col-sm-12 col-xxl-12 col-lg-12'>
                <CustomAddChipSearch
                    autocompleteId={'slt_fvf_host'}
                    buttonId={'btn_fvf_host'}
                    selectedList={employeeList}
                    setSelectedList={setEmployeeList}
                    userTypeIdsSearch={[USER_TYPE_MODEL.EMPLOYEE]}
                    disabled={false}
                    label="employee_to_visit"
                    emptyFields={emptyFields}
                    required={false}
                    reset={false}
                    hideButton={true}
                    keyId={"userId"}
                    showRenderOption={true}
                    maxLength={1}
                    helperText={t("press_enter_to_search_for_the_name_email_phone")}
                    api={PUBLIC_SEARCH_USERS_BY_USER_TYPE}
                    onlyOnKeyDown={true}
                    showSubSection={true}
                    sanitizeDataList={userListToLabelEmailPhoneValue}
                    Icon={PersonChipBlack}
                />
            </div>

            <RequestAccessForm
                t={t}
                emptyFields={emptyFields}
                requestAccessItem={requestAccessItem}
                disabled={false}
                photoPickerFile={photoPickerFile}
                setPhotoPickerFile={setPhotoPickerFile}
                handleChange={handleChange}
            />
        </div>
    );
};

export default VisitDetailsForm;
